import {Component, EventEmitter, inject, Output} from '@angular/core';
import {BaseComponent} from "../../../BaseComponent";
import {UserMetricGroup} from "../../../../models/user/Metric/UserMetricGroup";
import {DashboardService} from "../../../../services/dashboard/dashboard.service";

@Component({
  selector: 'app-chart-form-creation',
  templateUrl: './chart-form-creation.component.html',
  styleUrls: ['./chart-form-creation.component.css', '../../../common/dialog-style.css']
})
export class ChartFormCreationComponent extends BaseComponent {

  /**
   * Event that tells the father component to destroy this component
   */
  @Output('closeDialog') closeDialog = new EventEmitter();


  /**
   * Object containing new User Metric Group which will be used as the form data
   * @protected
   */
  protected newUserMetricGroup: UserMetricGroup;

  /**
   * Boolean flag used to store the validity of the form
   * @protected
   */
  protected isNewFormValid: boolean;

  /**
   * Service containing the shared data and procedures among dashboard components
   * @protected
   */
  protected dashboardService = inject(DashboardService);

  /**
   * When true deactivates the form until creation process is completed to avoid duplication for fast clicks
   * @protected
   */
  protected createRequestSent: boolean;


  constructor() {
    super();
    this.createRequestSent = false;
    this.isNewFormValid = false;
    this.newUserMetricGroup = new UserMetricGroup();
  }


  /**
   * Check if new group is valid, to enable SAVE button
   */
  checkNewGroupValidation(e: any) {
    this.isNewFormValid = !!this.newUserMetricGroup.name && !!this.newUserMetricGroup.name.replace(/\s/g, '').length;
  }


  /**
   * Method used on the destruction of the Popup component. It clears all the form data to avoid conflicts
   * @param _e
   */
  clearData(_e?: any) {
    this.newUserMetricGroup = new UserMetricGroup();
  }


  checkValidationAndSave() {
    if (this.isNewFormValid) {
      this.closeDialog.emit(this.newUserMetricGroup);
    }
  }

  popupHiding($event: any) {
    this.clearData($event);
    this.closeDialog.emit(false);
  }
}
